<template>
    <div>
        <b-modal id="create-group-key" title="Banka Dosyası Kimliği Oluştur" no-close-on-esc no-close-on-backdrop>
            <group-key-create v-model="groupKeyObject"></group-key-create>
            <template #modal-footer><v-executer :loading="groupKeyCreating" :action="createGroupKey" text="Oluştur"></v-executer></template>
        </b-modal>

        <b-card no-body class="mb-1 overflow-hidden">
            <b-overlay :show="getting" opacity="0.2">   
                <div class="p-1 pb-50">
                    <div class="row">
                        <div class="col-md-3 mb-1 mb-md-0">
                            <b-input-group class="input-group-merge v-table-search-input">
                                <template #prepend>
                                    <b-input-group-text >
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input v-on:keyup.enter="get()" v-model="searchValue" placeholder="Ara..." ></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <button class="btn btn-success btn-block" v-on:click="get()">
                                Sorgula
                            </button>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0 ml-auto">
                            <b-dropdown :disabled="acting" text="İşlemler" right variant="primary" v-if="(datas || []).length > 0">
                                <template #button-content>
                                    <b-spinner v-if="acting" small/>
                                    <template v-else>İşlemler</template>
                                </template>
                                <b-dropdown-item v-on:click="lock">
                                    <feather-icon icon="LockIcon" class="mr-50"></feather-icon>
                                    Tüm Maaşları Kilitle
                                </b-dropdown-item>
                                <b-dropdown-divider/>
                                <b-dropdown-form>
                                    <div class="row">
                                        <div class="col-12 mb-50">
                                            <select :disabled="groupKeyGetting" class="form-control" v-model="groupKey">
                                                <option :value="null" v-if="groupKey == null">Seçiniz</option>
                                                <option v-for="(gk,i) in groupKeys" :key="i" :value="gk.GroupKey">{{ gk.GroupKey }} - [{{ gk.DateStr }}] | ({{ gk.BankAccount.Bank.BankName }} - {{ gk.BankAccount.AccountNumber }})[{{gk.BankAccount.Name}}]</option>
                                            </select>
                                            <div class="d-flex g-50 mt-50"> 
                                                <v-executer class="btn-sm " :loading="groupKeyGetting" :action="getGroupKeys" text="Yenile" />
                                                <button type="button" v-on:click="showCreateGroupKey" class="btn btn-outline-secondary btn-sm w-100">Ekle</button>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <v-executer :action="sterlingAssign" :loading="assigning" class="text-nowrap" :disabled="!groupKey || !canSave" variant="success">Banka Dosyasına Gönder</v-executer>
                                        </div>
                                    </div>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div class="d-flex px-1 pb-50 g-50">
                    <small>Toplam {{ (datas || []).length }} Maaş</small>
                    <small class="text-danger">Ertelenen Toplam {{ (unselected || []).length }} Maaş</small>
                </div>
                <table class="table table-sm bordered-header">
                    <thead>
                        <tr>
                            <th v-if="(datas || []).length"></th>
                            <th class="w-100">Personel</th>
                            <th class="text-nowrap text-right">Tutar (TL)</th>
                            <th class="text-center">Kilitli</th>
                            <th class="text-nowrap">Banka Dosya Kimliği</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(d,i) in datas">
                            <tr :key="i">
                                <td>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <b-form-checkbox v-model="datas[i].Selected" class="pl-2"></b-form-checkbox>
                                    </div>
                                </td>
                                <td class="text-nowrap">
                                    <div class="d-flex align-items-center g-50" :class="{'unselected text-danger':$safe(d,'Selected') == false}">
                                        <span v-if="$safe(d,'ExitWarningMessage')"
                                              v-b-tooltip.hover.right="$safe(d,'ExitWarningMessage')"
                                              class="material-icons-outlined"
                                              :class="$safe(d,'ExitWarningLevel') === 'danger' ? 'text-danger' : 'text-warning'">
                                            {{ $safe(d,'ExitWarningLevel') === 'danger' ? 'report_problem' : 'logout' }}
                                        </span>
                                        {{ $safe(d,'EmployeeFullName') }}
                                    </div>
                                </td>
                                <td class="text-nowrap text-right">
                                    <div :class="{'unselected':$safe(d,'Selected') == false}">
                                        {{ $safe(d,'AmountStr') }}
                                    </div>
                                </td>
                                <td class="text-nowrap">
                                    <div class="d-flex justify-content-center">
                                        <span class="material-icons-outlined text-danger" v-if="!$safe(d,'Locked')">cancel</span>
                                        <span class="material-icons-outlined text-success" v-else>check_circle</span>
                                    </div>
                                </td>
                                <td class="text-nowrap text-right">{{ $safe(d,'GroupKey') }}</td>
                            </tr>
                            <tr v-if="$safe(d,'Selected') == false">
                                <td></td>
                                <td>
                                    <textarea :rows="1" v-model="datas[i].Desc" class="form-control resize-none" placeholder="Açıklama"></textarea>
                                </td>
                                <td colspan="3"></td>
                            </tr>
                        </template>
                        <tr v-if="(datas || []).length == 0">
                            <td class="text-center" colspan="5">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="d-flex px-1 py-50 g-50">
                    <small>Toplam {{ (datas || []).length }} Maaş</small>
                    <small class="text-danger">Ertelenen Toplam {{ (unselected || []).length }} Maaş</small>
                </div>
                <div class="mx-75 mb-1">
                    <div class="bg-light border rounded">
                        <div class="d-flex align-items-center p-50">
                            <div class="row justify-content-md-between justify-content-center text-success">
                                <div class="col-auto mb-1 mb-md-0">
                                    <div class="d-flex align-items-center g-50">
                                        <span class="material-icons-outlined" >calculate</span>
                                        <b>TOPLAM: {{total || 0}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BInputGroupText, BInputGroup, BFormInput,BDropdown, BDropdownItem, BSpinner, BPopover, BDropdownForm, BDropdownDivider, BOverlay, BFormCheckbox, VBTooltip } from 'bootstrap-vue';
import EmployeeOperationsApi from '@/api/employee-operations'
import GroupKeyCreate from './bes/GroupKeyCreate.vue';
import Additional from '@/utilities/additional';

export default {
    components:{
        BCard,
        BInputGroupText, 
        BInputGroup, 
        BFormInput,
        BDropdown, 
        BDropdownItem,
        BSpinner,
        BPopover,
        BDropdownForm,
        BDropdownDivider,
        GroupKeyCreate,
        BOverlay,
        BFormCheckbox
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:()=>({})
        },
    },
    mounted(){
        this.getGroupKeys()
    },
    data(){
        return {
            searchValue:null,
            acting:false,
            groupKey:null,
            groupKeys:[],
            groupKeyGetting:false,
            groupKeyCreating:false,
            groupKeyObject:{
                Date:null,
                CompanyBankAccountId:'F193BFD8-B2FF-4C0B-DAF2-08DD3BAC2777'
            },
            assigning:false,
            getting:false,
            datas:[]
        }
    },
    methods:{
        get(){
            this.getting = true
            EmployeeOperationsApi.LucaResult.ConfirmedTable({
                ...this.filter,
                PaginateRequest:{
                    QueryParam: this.searchValue || null,
                }
            }).then(res => {
                if(res.data.Success){
                    this.datas = (res.data.Data.Data || []).map(d => ({...d,Selected:true,Desc:null}))
                    this.getting = false
                }
            })
        },
        lock(){
            this.$confirm('Tüm maaşları kilitlemek istediğinize emin misiniz?','Bu işlem tüm personeller için maaşları kilitler ve geri alınamaz.').then(c => {
                if(c){
                    this.acting = true
                    EmployeeOperationsApi.LucaResult.Lock({
                        ...this.filter,
                        Lock:true,
                        PaginateRequest:{
                            ...this.paginate,
                            QueryParam: this.searchValue || null,
                        }
                    }).then(res => {
                        if(res.data.Success){
                            this.get()
                        }
                        this.$result(res)
                        this.acting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.acting = false
                    })
                }
            })
        },
        getGroupKeys(){
            this.groupKeyGetting = true
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyList(false).then(res => {
                this.groupKeys = res.data.Data
                this.groupKeyGetting = false
            }).catch(err => {
                this.groupKeyGetting = true
            })
        },
        sterlingAssign(){
            this.$confirm('Bu işlemi gerçekleştirmek istediğinizden emin misinz?','Yapmak üzere olduğunuz işlem, filtrelenen maaşları seçilen personeller hariç, seçtiğiniz kimlikle bir banka dosyasına atayacaktır. Devam etmek istediğinizden emin misiniz?').then(c => {
                if(c){
                    this.assigning = true
                    EmployeeOperationsApi.SalaryEffect.Assign.RSalarySterlingAssing({
                        Filter:{
                            ...this.filter,
                            PaginateRequest:{
                                ...this.paginate,
                                QueryParam: this.searchValue || null,
                            },
                        },
                        ExceptedRSalaryPayments: (this.datas || []).filter(d => d.Selected == false).map(d => ({
                            Id:d.RSalaryPaymentId,
                            Description:d.Desc
                        })),
                        GroupKey: this.groupKey
                    }).then(res => {
                        if(res.data.Success){
                            get()
                        }
                        this.$result(res)
                        this.assigning = false
                    })
                    .catch(err => {
                        this.$result(null,err)
                        this.assigning = false
                    })
                }
            })
        },
        showCreateGroupKey(){
            this.groupKeyObject.Date = null
            this.groupKeyObject.CompanyBankAccountId = null
            this.$showModal('create-group-key')
        },
        createGroupKey(){
            this.groupKeyCreating = true
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyCreate(this.groupKeyObject.Date,this.groupKeyObject.CompanyBankAccountId,1).then(res=>{
                this.groupKeyCreating = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create-group-key')
                    this.getGroupKeys()
                }
            }).catch(err => {
                this.groupKeyCreating = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        unselected(){
            return (this.datas || []).filter(s => s.Selected == false)
        },
        total(){
            return  Additional.ConvertMoney((this.datas || []).filter(s => s.Selected).reduce((s,i) => s+= (i.Amount || 0) ,0))
        },
        canSave(){
            return (this.datas || []).filter(d => d.Selected == false && (d.Desc || '').trim() == '' && d.Desc == null).length > 0 ? false : true
        }
    }
}
</script>

<style>
.unselected{
    opacity: .25;
}
</style>